export type PublicRuntimeConfig = {
  googleOAuthClientId?: string;
  googleSheetId?: string;
};

declare global {
  interface Window {
    __ASSET_MANAGEMENT_RUNTIME_CONFIG__?: PublicRuntimeConfig;
  }
}

export function resolveGoogleConfig(
  runtimeConfig: PublicRuntimeConfig | undefined,
  buildConfig: { VITE_GOOGLE_OAUTH_CLIENT_ID?: string; VITE_GOOGLE_SHEET_ID?: string },
) {
  return {
    clientId: runtimeConfig?.googleOAuthClientId?.trim() || buildConfig.VITE_GOOGLE_OAUTH_CLIENT_ID?.trim() || "",
    spreadsheetId: runtimeConfig?.googleSheetId?.trim() || buildConfig.VITE_GOOGLE_SHEET_ID?.trim() || "",
    scope: "https://www.googleapis.com/auth/spreadsheets",
  };
}

export const googleConfig = resolveGoogleConfig(
  typeof window === "undefined" ? undefined : window.__ASSET_MANAGEMENT_RUNTIME_CONFIG__,
  import.meta.env,
);

export function getConfigurationError() {
  const missing = [
    !googleConfig.clientId ? "VITE_GOOGLE_OAUTH_CLIENT_ID" : "",
    !googleConfig.spreadsheetId ? "VITE_GOOGLE_SHEET_ID" : "",
  ].filter(Boolean);
  return missing.length ? `${missing.join(", ")} 환경 설정이 필요합니다.` : "";
}
